import { FormFieldsStrategyType } from "../../types";

const adminFormWithCompany: FormFieldsStrategyType[] = [
  {
    label: "Title",
    name: "title",
    readonly: false,
    inputType: "select",
    defaultValue: "Mr.",
    options: [
      {
        label: "Mr.",
        value: "Mr.",
      },
      {
        label: "Ms.",
        value: "Ms.",
      },
    ],
    required: true,
  },
  {
    label: "Full Name",
    name: "fullName",
    readonly: false,
    inputType: "text",
    required: true,
  },
  {
    label: "Email Address",
    name: "email",
    readonly: false,
    inputType: "text",
    required: true,
    patternMessage: "Enter valid email",
    pattern:
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  },
  {
    label: "Phone Number",
    name: "phoneNumber",
    readonly: false,
    inputType: "text",
    required: true,
    pattern: /^\+?\d{8,}$/,
    patternMessage: "Enter valid phone number",
  },

  {
    label: "Designation",
    name: "designation",
    readonly: false,
    required: false,
    inputType: "text",
  },
  {
    label: "Location",
    name: "location",
    readonly: false,
    required: false,
    inputType: "text",
  },
  {
    label: "Role",
    name: "roleID",
    readonly: false,
    required: true,
    inputType: "select",
    defaultValue: "standard",
    options: [
      { label: "Admin", value: "admin" },
      { label: "Standard", value: "standard" },
    ],
  },
  {
    label: "Company name",
    name: "companyName",
    readonly: true,
    required: false,
    inputType: "text",
  },
];
const adminFormCreate: FormFieldsStrategyType[] = [
  {
    label: "Title",
    name: "title",
    readonly: false,
    inputType: "select",
    required: true,
    options: [
      {
        label: "Mr.",
        value: "Mr.",
      },
      {
        label: "Ms.",
        value: "Ms.",
      },
    ],
  },
  {
    label: "Full Name",
    name: "fullName",
    readonly: false,
    inputType: "text",
    required: true,
  },
  {
    label: "Email Address",
    name: "email",
    readonly: false,
    inputType: "text",
    required: true,
    patternMessage: "Enter valid email",
    pattern:
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  },
  {
    label: "Phone Number",
    name: "phoneNumber",
    readonly: false,
    inputType: "text",
    required: true,
    pattern: /^\+?\d{8,}$/,
    patternMessage: "Enter valid phone number",
  },

  {
    label: "Designation",
    name: "designation",
    readonly: false,
    required: false,
    inputType: "text",
  },
  {
    label: "Location",
    name: "location",
    readonly: false,
    required: false,
    inputType: "text",
  },
  {
    label: "Role",
    name: "role",
    readonly: true,
    required: true,
    inputType: "text",
    defaultValue: "Admin",
  },
];
const createAIRXAdmin: FormFieldsStrategyType[] = [
  {
    label: "Title",
    name: "title",
    readonly: false,
    inputType: "select",
    required: true,
    defaultValue: "Mr.",
    options: [
      {
        label: "Mr.",
        value: "Mr.",
      },
      {
        label: "Ms.",
        value: "Ms.",
      },
    ],
  },
  {
    label: "Full Name",
    name: "fullName",
    readonly: false,
    inputType: "text",
    required: true,
  },
  {
    label: "Email Address",
    name: "email",
    readonly: false,
    inputType: "text",
    required: true,
    patternMessage: "Enter valid email",
    pattern:
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  },
  {
    label: "Phone Number",
    name: "phoneNumber",
    readonly: false,
    inputType: "text",
    required: true,
    pattern: /^\+?\d{8,}$/,
    patternMessage: "Enter valid phone number",
  },
  {
    label: "Designation",
    name: "designation",
    readonly: false,
    required: false,
    inputType: "text",
  },
  {
    label: "Role",
    name: "roleID",
    readonly: false,
    required: true,
    inputType: "select",
    defaultValue: "admin",
    options: [
      { label: "Admin", value: "admin" },
      { label: "Standard", value: "standard" },
    ],
  },
];
export { adminFormWithCompany, adminFormCreate, createAIRXAdmin };
